import React from "react";

const LOGO_URL = `${process.env.PUBLIC_URL || ""}/webjesters-mark.png`;

export const Logo = ({ size = 30, withWordmark = true, withSubtitle = false, testid = "brand-logo", className = "" }) => (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid={testid}>
        <img
            src={LOGO_URL}
            alt="WebJesters"
            width={size}
            height={size}
            className="shrink-0 select-none"
            draggable={false}
        />
        {withWordmark && (
            <span className="flex flex-col leading-tight">
                <span className="text-[15px] font-semibold text-zinc-100">WebJesters</span>
                {withSubtitle && <span className="mt-0.5 text-[10px] portal-brand-text">Command Center</span>}
            </span>
        )}
    </div>
);

export default Logo;
